import { useOutlet } from "react-router-dom";
import { isInIframe } from "@/utils";
import { Header } from "./head";
import styles from "./style.module.scss";
import footerStyles from "./header-footer-layout.module.scss";
import { Footer } from "./footer";

export const HeaderFooterLayout = () => {
  const outlet = useOutlet();
  const isIframe = isInIframe();
  const isBuyer = [
    "/e-goods",
    "/preorder",
    "/checkorder",
    "/pay-success",
  ].includes(window.location.pathname);

  const footerInfo = {
    logo: "https://public-daqihui-prod.oss-cn-hangzhou.aliyuncs.com/fe-resources/cxfe/statics/svg/logo-Black.svg",
    info: [
      {
        icon: [
          "https://public-daqihui-prod.oss-cn-hangzhou.aliyuncs.com/fe-resources/cxfe/statics/img/footer-logo1.png",
        ],
        title: "浙公网安备 33010802003150号",
      },
      {
        icon: [
          "https://public-daqihui-prod.oss-cn-hangzhou.aliyuncs.com/fe-resources/cxfe/statics/img/footer-logo2.png",
        ],
        title: "备案/许可证号：浙ICP备13004315号-7",
      },
    ],
  };

  return (
    <div className={styles.globalWrapper} style={{ backgroundColor: "#fff" }}>
      {/* 头部 */}
      {!isInIframe() && <Header noTabs />}

      {/* 主内容区域 */}
      <div
        style={{
          width: "100%",
          ...(isBuyer ? { background: "#F5F6F7" } : { minHeight: "100vh" }),
        }}
      >
        {outlet}
      </div>

      {/* 简化尾部 - 只显示备案信息 */}
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          backgroundColor: "#F5F6F7",
        }}
      >
        {!isIframe && <Footer />}
      </div>

      {/* {
        !isInIframe() && (
          <div className={footerStyles.footerBottom}>
            <div className={footerStyles.footerLogoWrapper}>
              <img
                alt=""
                src={footerInfo.logo}
                className={footerStyles.footerLogo}
              />
            </div>
            <div className={footerStyles.footerInfoGroup}>
              {footerInfo.info.map((item, index) => (
                <div key={`footer-info-${index}`} className={footerStyles.footerInfoItem}>
                  {item.icon?.map((icon, iconIndex) => (
                    <img
                      key={`icon-${iconIndex}`}
                      alt=""
                      src={icon}
                      className={footerStyles.footerInfoIcon}
                    />
                  ))}
                  <span>{item.title}</span>
                </div>
              ))}
            </div>
          </div>
        )
      } */}
    </div>
  );
};
